/* eslint-disable no-duplicate-case */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-void */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { ReactNode, useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";
import { SkillMapCellStatus, TargetType, CAREER_TYPE_ELEARNING, CAREER_TYPE_CLASSROOM, CAREER_TYPE_CURRICULUM } from "../../Constants";

import type { SkillProps } from "./Skill";
import { ZINDEX_DRAWER, useScreenSize } from "../../component/Theme";
import CareerCard from "../../component/card/CareerCard";
import SompoCardContent from "../../component/card/SompoCardContent";
import SettingButton from "../../component/button/SettingButton";
import GoalIcon from "../../component/icons/GoalIcon";
import SompoTextField from "../../component/textField/SompoTextField";
import CurriculumCard from "../../component/card/CurriculumCard";
import SompoLoading from "../../component/loading/SompoLoading";

import { MainCategory } from "../../logic/hook/useCategories";
import SkillMapCellTargetService from "../../logic/api/SkillMapCellTargetService";
import SkillMapCellTargetResetService from "../../logic/api/SkillMapCellTargetResetService";
import SkillMapRootDataService, { SkillMapRootDataResponse } from "../../logic/api/SkillMapRootDataService";
import { CellSubCareerItem } from "../../logic/api/SkillMapCellService";
import { openInformationDialog, showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SompoContext from "../../logic/context/SompoContext";
import { ResultStatusProvider, useSubcareersStatusConversion, useCarriculaStatusConversion } from "../../logic/utility/replaceLabels";

// Logics.
const cellTargetService = new SkillMapCellTargetService();
const skillMapRootDataService = new SkillMapRootDataService();
const cellTargetResetService = new SkillMapCellTargetResetService();

// Sub components.
const SkillDrawerCardCareer = (props: {
    career: CellSubCareerItem;
    index: number;
    compulsoryIdList: { [careerId: string]: string };
    getTargetCategory: (category: string) => MainCategory | undefined;
}) => {
    // Props.
    const { career: cellSubCareerItem, index, compulsoryIdList, getTargetCategory } = props;

    // Hooks.
    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    // #19063: ステータス置き換え
    const status = useSubcareersStatusConversion(cellSubCareerItem);

    // Event handlers.
    const navigateToDetail = () => {
        navigate(`/training/detail/${cellSubCareerItem.careerId}`, {
            state: { check: false, classId: cellSubCareerItem.classId },
        });
    };

    // Render component.
    const el = cellSubCareerItem.careerTypeId === CAREER_TYPE_ELEARNING;
    const gt = cellSubCareerItem.careerTypeId === CAREER_TYPE_CLASSROOM;
    return (
        <CareerCard
            thumbnail={cellSubCareerItem.careerImageUrl}
            tooltip={cellSubCareerItem.careerTitle}
            badge={compulsoryIdList[cellSubCareerItem.careerId]}
            onClick={navigateToDetail}
        >
            <SompoCardContent
                sx={{
                    height: "175px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    textAlign: "left",
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            width: "100%",
                            fontSize: "1rem",
                            fontWeight: "bold",
                            minHeight: "2lh",
                            wordBreak: "break-all",
                            overflowX: "hidden",
                        }}
                        className="ellipses2"
                    >
                        {cellSubCareerItem.careerTitle}
                    </Typography>
                    <Box
                        sx={{
                            bgcolor: "primary.main",
                            borderRadius: "7px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mt: 1,
                            pl: desktop ? 1 : 0.2,
                            pr: desktop ? 1 : 0.2,
                            width: "fit-content",
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                color: "#fefefe",
                            }}
                        >
                            {getTargetCategory(cellSubCareerItem.careerId)?.name}
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    {el && (
                        <Typography variant="body2" className="ellipses2">
                            eラーニング
                        </Typography>
                    )}
                    {gt && (
                        <Typography variant="body2" className="ellipses2">
                            集合研修
                        </Typography>
                    )}
                    <Typography variant="body2" className="ellipses2">
                        {status}
                    </Typography>
                </Box>
            </SompoCardContent>
        </CareerCard>
    );
};

const SkillDrawerCardCurriculum = (props: {
    curriculum: CellSubCareerItem;
    index: number;
    compulsoryIdList: { [careerId: string]: string };
    getTargetCategory: (category: string) => MainCategory | undefined;
}) => {
    // Props.
    const { curriculum, index, compulsoryIdList, getTargetCategory } = props;

    // Hooks.
    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    // #19063: ステータス置き換え
    const status = useCarriculaStatusConversion(curriculum);

    // Event handlers.
    const navigateToDetail = () => navigate(`/curriculum/detail/${curriculum.careerId}`);

    // Render component.
    const compulsoryId = compulsoryIdList[curriculum.careerId];
    return (
        <CurriculumCard
            tooltip={curriculum.careerTitle}
            badge={compulsoryId}
            onClick={navigateToDetail}
        >
            <SompoCardContent
                sx={{
                    height: "175px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    textAlign: "left",
                    gap: 0.4,
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            width: "100%",
                            fontSize: "1rem",
                            fontWeight: "bold",
                            minHeight: "2lh",
                            wordBreak: "break-all",
                            overflowX: "hidden",
                        }}
                        className="ellipses2"
                    >
                        {curriculum.careerTitle}
                    </Typography>
                    <Box
                        sx={{
                            bgcolor: "primary.main",
                            borderRadius: "7px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mt: 1,
                            pl: desktop ? 1 : 0.2,
                            pr: desktop ? 1 : 0.2,
                            width: "fit-content",
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                color: "#fefefe",
                            }}
                        >
                            {getTargetCategory(curriculum.careerId)?.name}
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    <Typography variant="body2">カリキュラム</Typography>
                    <Typography variant="body2">{status}</Typography>
                </Box>
            </SompoCardContent>
        </CurriculumCard>
    );
};

// 実際に表示されるコンポーネント
const SkillDrawer = (props: SkillProps) => {
    // Hooks.
    const { desktop } = useScreenSize();

    // Context.
    const sompoContext = React.useContext(SompoContext);

    // States.
    const [settingCmcId, setSettingCmcId] = useState(""); // 選択したレベルのスキルマップセルID
    const [settingModalOpen, setSettingDrawerOpen] = useState(false); // 目標設定ドロワーの開閉
    const [settingComment, setSettingComment] = useState(""); // 目標設定ドロワー_コメント
    const [newSettingFlag, setNewSettingFlag] = useState(false); // 目標設定ドロワー_新規で設定するかどうか
    const [radioValue, setRadioValue] = useState(TargetType.SHORT_TERM); // ラジオボタンの値(初期値は短期目標)
    const [skillMapRootData, setSkillMapRootData] = useState<SkillMapRootDataResponse>({} as SkillMapRootDataResponse); // スキルマップデータ取得用

    // Side effects.
    //
    useEffect(() => {
        setSkillMapRootData(props.skillMapRootData);
    }, [props.skillMapRootData]);

    // スキルマップ選択時に分野とスキルマップデータを取得
    useEffect(() => {
        if (props.cmId) {
            // スキルマップが選択されている場合
            sompoContext.setSkillMapDrawerLoading(true);
            if (!Environments.MOCK) {
                const fetch = async () => {
                    try {
                        await skillMapRootDataService.skillMapRootData(
                            { cmId: props.cmId, rootId: props.rootId },
                            (_skillMapRootData: SkillMapRootDataResponse) => {
                                setSkillMapRootData(_skillMapRootData);
                                sompoContext.setSkillMapDrawerLoading(false);
                            },
                            (error: any) => {
                                throw error;
                            }
                        );
                    } catch (error: any) {
                        console.error(error);
                        showErrorMessage({ message: "分野の取得に失敗しました。", error });
                        setSkillMapRootData({} as SkillMapRootDataResponse);
                        sompoContext.setSkillMapDrawerLoading(false);
                    }
                };
                fetch();
            } else {
                const cellData: { [id: string]: SkillMapRootDataResponse } = MOCK_DATA.USER.SKILL_MAP.DATA;
                let _cellData: SkillMapRootDataResponse = {} as SkillMapRootDataResponse;
                for (const _fieldId of Object.keys(cellData)) {
                    if (_fieldId === props.cmId) {
                        _cellData = cellData[_fieldId];
                        break;
                    }
                }
                setSkillMapRootData(_cellData);
                sompoContext.setSkillMapDrawerLoading(false);
            }
        } else {
            // スキルマップが選択されていない場合
            setSkillMapRootData({} as SkillMapRootDataResponse);
        }
    }, [props.renderCount]);

    // Event handlers.
    // ラジオボタン選択時
    const handleRadioValueChange = (event: { target: { value: string } }) => {
        setRadioValue(event.target.value);
    };

    // 目標設定ドロワー_コメント入力
    const handleSettingCommentChange = (event: { target: { value: string } }) => {
        setSettingComment(event.target.value);
    };

    // 目標設定ドロワーを閉じる際に、値を初期値に戻す
    const closeSettingModal = () => {
        setSettingDrawerOpen(false);
        setRadioValue(TargetType.SHORT_TERM);
        setSettingComment("");
        setNewSettingFlag(false);
    };

    // 講座ドロワー内のステータスアイコンを表示
    const displayTargetIcon = (cmcId: string, statusId: string) => {
        const matchSkillMapRootData = skillMapRootData.levelData?.find((levelItem) => levelItem.cmcId === cmcId);
        const type = String(matchSkillMapRootData ? matchSkillMapRootData.targetType : TargetType.UNSET); // 目標種別

        // 短期/長期目標のアイコン
        let icon: ReactNode = <></>;
        switch (type) {
            case TargetType.SHORT_TERM:
                if (type === TargetType.SHORT_TERM) {
                    icon = <GoalIcon title="短期目標" />;
                }
                break;
            case TargetType.LONG_TERM:
                if (type === TargetType.LONG_TERM) {
                    icon = <GoalIcon title="長期目標" />;
                }
                break;
            default:
                break;
        }

        // 目標設定/目標設定変更のボタン
        let button: ReactNode = <></>;

        // 目標達成している場合はボタンを表示しない
        if (statusId !== SkillMapCellStatus.ACHIEVED) {
            switch (type) {
                case TargetType.UNSET:
                    button = type === TargetType.UNSET && (
                        <SettingButton
                            drawerOpener={setSettingDrawerOpen}
                            setSettingCmcId={setSettingCmcId}
                            cmcId={cmcId}
                            setNewSettingFlag={setNewSettingFlag}
                            title="目標を設定してください"
                        />
                    );
                    break;
                case TargetType.SHORT_TERM:
                    button = type !== TargetType.UNSET && (
                        <SettingButton drawerOpener={setSettingDrawerOpen} setSettingCmcId={setSettingCmcId} cmcId={cmcId} title="変更" />
                    );
                    break;
                case TargetType.LONG_TERM:
                    button = type !== TargetType.UNSET && (
                        <SettingButton drawerOpener={setSettingDrawerOpen} setSettingCmcId={setSettingCmcId} cmcId={cmcId} title="変更" />
                    );
                    break;
                default:
                    break;
            }
        }

        return (
            <>
                {icon} {button}
            </>
        );
    };

    // 目標設定のイベント処理
    const setTarget = () => {
        if (!Environments.MOCK) {
            const fetch = async () => {
                await cellTargetService.skillMapCellTarget(
                    {
                        cmId: props.cmId,
                        cmcId: settingCmcId,
                        target: radioValue,
                        comment: settingComment,
                    },
                    () => {
                        openInformationDialog({ message: "目標設定を行いました。" });
                        closeSettingModal();
                        props.setRenderCount(props.renderCount + 1);
                    },
                    (error: any) => {
                        console.error(error);
                        showErrorMessage({ message: "目標設定に失敗しました。", error });
                        closeSettingModal();
                    }
                );
            };
            void fetch();
        } else {
            openInformationDialog({ message: "目標設定を行いました。" });
            closeSettingModal();
        }
    };

    // 目標設定変更のイベント処理
    const resetTarget = () => {
        if (!Environments.MOCK) {
            const fetch = async () => {
                await cellTargetResetService.skillMapCellTargetReset(
                    {
                        cmId: props.cmId,
                        cmcId: settingCmcId,
                        comment: settingComment,
                    },
                    () => {
                        openInformationDialog({ message: "目標設定を変更しました。" });
                        closeSettingModal();
                        props.setRenderCount(props.renderCount + 1);
                    },
                    (error: any) => {
                        console.error(error);
                        showErrorMessage({ message: "目標設定の変更に失敗しました。", error });
                        closeSettingModal();
                    }
                );
            };
            void fetch();
        } else {
            openInformationDialog({ message: "目標設定を変更しました。" });
            closeSettingModal();
        }
        props.setRenderCount(props.renderCount + 1);
    };

    const drawerStyle = {
        zIndex: ZINDEX_DRAWER,
        "& .MuiDrawer-paper": {
            width: desktop ? "70% !important" : "100% !important",
        },
    };

    return (
        <ResultStatusProvider> {/* #19063: ステータス置き換え */}
            {/* 講座ドロワー */}
            <Drawer
                anchor="right"
                open={props.trainingDrawerOpen}
                onClose={() => {
                    props.setTrainingDrawerOpen(false);
                    setSkillMapRootData({} as SkillMapRootDataResponse);
                }}
                sx={drawerStyle}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        display: "flex",
                        flexFlow: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        p: 2,
                        pb: 8,
                    }}
                >
                    {sompoContext.skillMapDrawerLoading ? (
                        <SompoLoading />
                    ) : (
                        <>
                            <Box sx={{ textAlign: "right", width: "90%" }}>
                                <IconButton
                                    onClick={(event: React.MouseEvent<unknown>) => {
                                        props.setTrainingDrawerOpen(false);
                                        event.stopPropagation();
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <Typography variant="h5" sx={{ textAlign: "left", width: "90%", wordBreak: "break-all" }}>
                                {props.skillMapFieldTitle}
                            </Typography>

                            {props.skillMapCell.cellData?.map((cellDataItem, cellDataItemIndex) => (
                                <Box
                                    key={cellDataItemIndex}
                                    sx={{ width: "90%", bgcolor: "#F5F6F6", height: "auto", mt: 2, p: 2, flexShrink: 0, borderRadius: "10px" }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", columnGap: "0.5em" }}>
                                        <Typography
                                            variant="h5"
                                            sx={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "flex-start" }}
                                        >
                                            {cellDataItem.levelTitle}
                                        </Typography>
                                        {displayTargetIcon(cellDataItem.cmcId, cellDataItem.statusId)}
                                    </Box>

                                    <Box
                                        sx={{
                                            height: "auto",
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            overflowX: "scroll",
                                            pb: 1,
                                            columnGap: 2,
                                        }}
                                    >
                                        {(cellDataItem.cellSubCareer || []).map((cellSubCareerItem, cellSubCareerItemIndex) => {
                                            const { careerTypeId, careerId, classId } = cellSubCareerItem;
                                            switch (careerTypeId) {
                                                case CAREER_TYPE_ELEARNING:
                                                case CAREER_TYPE_CLASSROOM:
                                                    return (
                                                        <SkillDrawerCardCareer
                                                            key={`SkillDrawerCardCareer-${careerId}-${classId}`}
                                                            career={cellSubCareerItem}
                                                            index={cellSubCareerItemIndex}
                                                            compulsoryIdList={props.compulsoryIdList}
                                                            getTargetCategory={props.categories.getTargetCategory}
                                                        />
                                                    );

                                                case CAREER_TYPE_CURRICULUM:
                                                    return (
                                                        <SkillDrawerCardCurriculum
                                                            key={`SkillDrawerCardCurriculum-${careerId}-${classId}`}
                                                            curriculum={cellSubCareerItem}
                                                            index={cellSubCareerItemIndex}
                                                            compulsoryIdList={props.compulsoryIdList}
                                                            getTargetCategory={props.categories.getMainCategoryCurriculum}
                                                        />
                                                    );

                                                default:
                                                    return <></>;
                                            }
                                        })}
                                    </Box>
                                </Box>
                            ))}
                        </>
                    )}
                </Box>
            </Drawer>

            {/* 目標設定ドロワー */}
            <Drawer hideBackdrop anchor="right" open={settingModalOpen} onClose={closeSettingModal} sx={drawerStyle}>
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        display: "flex",
                        flexFlow: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        p: 2,
                    }}
                >
                    <Box sx={{ textAlign: "left", width: "90%" }}>
                        <Button
                            onClick={(event: React.MouseEvent<unknown>) => {
                                closeSettingModal();
                                event.stopPropagation();
                            }}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "333",
                            }}
                        >
                            <KeyboardArrowLeftIcon />
                            <Typography variant="h5">戻る</Typography>
                        </Button>

                        <Grid
                            container
                            direction="column"
                            justifyContent="space-evenly"
                            alignItems="center"
                            flexWrap={"nowrap"}
                            sx={{
                                height: "100%",
                                width: "100%",
                                borderRadius: "10px",
                                bgcolor: "background.paper",
                                outline: "none",
                            }}
                        >
                            <Grid item>
                                <Typography variant="h5">目標設定</Typography>
                            </Grid>
                            <Grid item sx={{ width: desktop ? "80%" : "100%" }}>
                                <FormControl
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <RadioGroup
                                        row={!!desktop}
                                        defaultValue={TargetType.SHORT_TERM}
                                        value={radioValue}
                                        onChange={handleRadioValueChange}
                                    >
                                        <FormControlLabel
                                            value={TargetType.SHORT_TERM}
                                            control={<Radio />}
                                            label={<Typography variant="h6">短期目標</Typography>}
                                        />
                                        <FormControlLabel
                                            value={TargetType.LONG_TERM}
                                            control={<Radio />}
                                            label={<Typography variant="h6">長期目標</Typography>}
                                        />
                                        <FormControlLabel
                                            disabled={newSettingFlag}
                                            value={TargetType.UNSET}
                                            control={<Radio />}
                                            label={
                                                <Typography variant="h6" sx={{ opacity: newSettingFlag ? 0.6 : 1 }}>
                                                    目標をやめる
                                                </Typography>
                                            }
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item sx={{ width: desktop ? "80%" : "100%" }}>
                                <SompoTextField
                                    multiline
                                    rows={8}
                                    fullWidth
                                    label={<Typography variant="h6">コメント</Typography>}
                                    sx={{ size: { sm: "small", md: "medium" }, m: 1 }}
                                    onChange={handleSettingCommentChange}
                                    InputProps={{
                                        multiline: true,
                                        inputComponent: "textarea",
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    sx={{
                                        border: "1px solid #ddd",
                                        pt: desktop ? 2 : 1,
                                        pb: desktop ? 2 : 1,
                                        pl: desktop ? 5 : 3,
                                        pr: desktop ? 5 : 3,
                                    }}
                                    onClick={() => {
                                        closeSettingModal();
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: "#333",
                                        }}
                                    >
                                        キャンセル
                                    </Typography>
                                </Button>
                                <Button
                                    sx={{
                                        ml: 2,
                                        pt: desktop ? 2 : 1,
                                        pb: desktop ? 2 : 1,
                                        pl: desktop ? 5 : 3,
                                        pr: desktop ? 5 : 3,
                                        transition: "all 0.2s ease-in-out",
                                        bgcolor: "primary.main",
                                        "&: hover": {
                                            backgroundColor: "primary.main",
                                            opacity: 0.7,
                                        },
                                    }}
                                    onClick={() => {
                                        radioValue !== "-1" ? setTarget() : resetTarget();
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: "#fefefe",
                                        }}
                                    >
                                        設定する
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Drawer>
        </ResultStatusProvider>
    );
};

export default SkillDrawer;
